// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wet-runway-braking-friction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wet-runway-braking-friction/wet-runway-braking-friction.js';

mount([g0]);
